<template>
  <div class="position-ab">
    <div class="ccui-app-iframe-no-operate-container">
      <breadcrumbSourcing
        :breadcrumb-data="breadcrumbData"
      ></breadcrumbSourcing>
      <div class="ccui-app-iframe-container-no-operate-detail">
        <div
          class="ccui-app-iframe-container-detail-body"
          style="margin-bottom:50px"
        >
          <div class="ccui-tab-iframe">
            <div class="ccui-tab-wrapper">
              <el-button type="table-top-active" size="mini">
                评分表模板
              </el-button>
            </div>
            <el-checkbox class="chooseCheck" v-model="checked" disabled
              >去掉最低分和最高分（仅限技术评分）</el-checkbox
            >
          </div>
          <!--        <el-tabs class="el-tabs__customize">-->
          <!--          <el-tab-pane label="评分表模板">-->
          <el-table :data="tableData" border :span-method="objectSpanMethod">
            <!-- <el-table-column
              v-for="(item, index) in columns"
              :key="index"
              :show-overflow-tooltip="true"
              v-bind="item"
            >
            </el-table-column> -->
            <el-table-column label="序号" width="50" prop="id" />
            <el-table-column
              v-if="isShowPack"
              prop="packName"
              label="包件名称"
              width="250"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="scoreItemStr"
              label="评审项目"
              width="250"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="weight"
              label="项目权重"
              width="250"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="scoreRule"
              label="评审细则"
              width="250"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="scoreWeight"
              label="细则权重"
              width="250"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="scoreStandard"
              label="评审标准"
              width="250"
              show-overflow-tooltip
            ></el-table-column>
          </el-table>
          <!--          </el-tab-pane>-->
          <!--        </el-tabs>-->
          <!--        <el-checkbox class="chooseCheck" v-model="checked" disabled-->
          <!--          >去掉最低分和最高分（仅限技术评分）</el-checkbox-->
          <!--        >-->
        </div>
      </div>
      <div class="operate">
        <el-button type="text" icon="icon-ccui-download" @click="exportPdf"
          >导出</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumbSourcing from "@/app/sourcingFlow/components/breadcrumb-sourcing.vue";
import { qryScoreListApi } from "@/app/sourcingFlow/api/expertEvaluation.js";
import { exportJsonToExcel } from "@/basa/utils/Export2Excel";

export default {
  name: "viewScoreItems",
  components: {
    breadcrumbSourcing
  },
  data() {
    return {
      breadcrumbData: {
        titname: "评分项查看"
      },
      checked: false,
      tableData: [],
      columns: [
        {
          prop: "id",
          label: "序号",
          width: 55
        },
        {
          prop: "packName",
          label: "包件名称",
          width: 220
        },
        {
          prop: "scoreItemStr",
          label: "评审项目",
          width: 140
        },
        {
          prop: "weight",
          label: "项目权重",
          width: 140
        },
        {
          prop: "scoreRule",
          label: "评审细则",
          width: 220
        },
        {
          prop: "scoreWeight",
          label: "细则权重",
          width: 140
        },
        {
          prop: "scoreStandard",
          label: "评审标准"
        }
      ],
      isShowPack: false,
      tableCopy: []
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      qryScoreListApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res => {
        if (res.data.data && res.data.data.rows.length > 0) {
          this.tableCopy = res.data.data.rows;
          this.checked = res.data.data.sumForm === "102";
          let data = [];
          let devspan = 0;
          let indexk = 0;
          res.data.data.rows.forEach((item, index) => {
            item.sscScoreBOS.forEach((itemtow, indextow) => {
              indexk = indexk + 1;
              // if (indextow > 0) {
              //   if(index !== 0){
              //         res.data.data.rows[index -1].sscScoreBOS.forEach(aItem => {
              //           devspan +=aItem.sscScoreItemBOS.length;
              //         })
              //   }else{
              //     devspan +=
              //         item.sscScoreBOS[indextow - 1].sscScoreItemBOS.length;
              //   }
              // }
              if (itemtow.packId == 0) {
                this.isShowPack = false;
              } else {
                this.isShowPack = true;
              }
              if (index > 0) {
                if (indextow > 0) {
                  devspan +=
                    item.sscScoreBOS[indextow - 1].sscScoreItemBOS.length;
                } else {
                  if (res.data.data.rows[index - 1].sscScoreBOS.length === 2) {
                    devspan +=
                      res.data.data.rows[index - 1].sscScoreBOS[1]
                        .sscScoreItemBOS.length;
                  } else if (
                    res.data.data.rows[index - 1].sscScoreBOS.length === 1
                  ) {
                    devspan +=
                      res.data.data.rows[index - 1].sscScoreBOS[0]
                        .sscScoreItemBOS.length;
                  }
                }
              } else {
                if (indextow > 0) {
                  devspan +=
                    item.sscScoreBOS[indextow - 1].sscScoreItemBOS.length;
                }
              }
              // if(indextow > 0){
              //   devspan += itemtow.sscScoreItemBOS.length - item.sscScoreBOS[indextow - 1].sscScoreItemBOS.length;
              // }else{
              //   if(index > 0){
              //     if(res.data.data.rows[index - 1].sscScoreBOS.length  === 2){
              //       devspan += itemtow.sscScoreItemBOS.length - res.data.data.rows[index - 1].sscScoreBOS[1].sscScoreItemBOS.length;
              //     }else if(res.data.data.rows[index - 1].sscScoreBOS.length  === 1){
              //       devspan += itemtow.sscScoreItemBOS.length - res.data.data.rows[index - 1].sscScoreBOS[0].sscScoreItemBOS.length;
              //     }else{
              //       devspan += itemtow.sscScoreItemBOS.length;
              //     }
              //   }
              // }
              itemtow.sscScoreItemBOS.forEach((itemthree, indexthree) => {
                // indexk += 1;
                data.push({
                  // id: indextow + 1,
                  id: indexk,
                  packName: item.packName,
                  packId: item.packId,
                  scoreItem: itemtow.scoreItem,
                  scoreItemStr: itemtow.scoreItemStr,
                  weight: itemtow.weight,
                  sumForm: itemtow.sumForm,
                  scoreRule: itemthree.scoreRule,
                  scoreWeight: itemthree.scoreWeight,
                  scoreStandard: itemthree.scoreStandard,
                  rowspan: itemtow.sscScoreItemBOS.length,
                  devspan: devspan
                });
              });
            });
          });
          console.log(data);
          this.tableData = data;
        }
      });
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (
        (columnIndex < 4 && this.isShowPack) ||
        (columnIndex < 3 && !this.isShowPack)
      ) {
        if ((rowIndex - row.devspan) % row.rowspan === 0) {
          return {
            rowspan: row.rowspan,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    // 导出开始
    exportPdf() {
      this.exportData = [];
      if (this.tableData > 5000) {
        this.$message({
          message: "暂不支持5000行以上大批量数据导出",
          type: "warning",

          offset: document.documentElement.clientHeight / 2 - 21
        });
      } else {
        let id = 0;
        this.tableCopy.forEach((item, index) => {
          item.sscScoreBOS.forEach(aItem => {
            aItem.sscScoreItemBOS.forEach(bItem => {
              this.exportData.push({
                // id: 1 + index,
                id: id++,
                packName: item.packName,
                scoreItemStr: aItem.scoreItemStr,
                weight: aItem.weight,
                scoreRule: bItem.scoreRule,
                scoreWeight: bItem.scoreWeight,
                scoreStandard: bItem.scoreStandard
              });
            });
          });
        });
        if (this.ExcelJS) {
          this.exportDefaultAll();
        } else {
          this.exportCompatibleAll();
        }
      }
    },
    async exportDefaultAll() {
      const wb = new this.ExcelJS.Workbook();
      const ws1 = wb.addWorksheet("评分项查看");
      ws1.views = [{ state: "frozen", ySplit: 1 }];

      ws1.addRow(["评分项查看"]);
      ws1.addRow([this.content]);
      ws1.addRow([
        "序号",
        "包件名称",
        "评审项目",
        "项目权重",
        "评审细则",
        "细则权重",
        "评审标准"
      ]);
      ws1.columns = [
        { key: "id", width: 5 },
        { key: "packName", width: 25 },
        { key: "scoreItemStr", width: 25 },
        { key: "weight", width: 25 },
        { key: "scoreRule", width: 50 },
        { key: "scoreWeight", width: 25 },
        { key: "scoreStandard", width: 50 }
      ];
      let oneSpanList = [];
      let twoSpanList = [];
      let start = 4;
      let twoStart = 4;
      this.tableCopy.forEach((item, index) => {
        let devspan = 0;
        item.sscScoreBOS.forEach(a => {
          devspan += a.sscScoreItemBOS.length;
        });
        item.sscScoreBOS.forEach((aItem, aIndex) => {
          let twoDevSpan = 0;
          twoDevSpan += aItem.sscScoreItemBOS.length;
          aItem.sscScoreItemBOS.forEach(bItem => {
            ws1.addRow([
              index + 1,
              item.packName,
              aItem.scoreItemStr,
              aItem.weight,
              bItem.scoreRule,
              bItem.scoreWeight,
              bItem.scoreStandard
            ]);
          });
          twoSpanList.push({
            start: twoStart,
            end: twoDevSpan + twoStart - 1
          });
          twoStart = twoDevSpan + twoStart;
        });
        oneSpanList.push({
          start: start,
          end: devspan + start - 1
        });
        start = devspan + start;
      });
      oneSpanList.forEach(item => {
        ws1.mergeCells("A" + item.start + ":A" + item.end);
        if (this.isShowPack) {
          ws1.mergeCells("B" + item.start + ":B" + item.end);
        }
      });
      twoSpanList.forEach(item => {
        ws1.mergeCells("C" + item.start + ":C" + item.end);
        ws1.mergeCells("D" + item.start + ":D" + item.end);
      });
      const buf = await wb.xlsx.writeBuffer();
      this.saveAs(new Blob([buf]), "评分项查看.xlsx");
    },
    exportCompatibleAll() {
      const header = [
        "序号",
        "包件名称",
        "评审项目",
        "项目权重",
        "评审细则",
        "细则权重",
        "评审标准"
      ];
      const filterVal = [
        "id",
        "packName",
        "scoreItemStr",
        "weight",
        "scoreRule",
        "scoreWeight",
        "scoreStandard"
      ];
      const excelArr = this.exportData;
      let count = 0;
      const list = [];
      excelArr.forEach((val, index) => {
        val.index = ++count;
        list.push(val);
      });
      const data = this.formatJson(filterVal, list);
      exportJsonToExcel({
        header,
        data,
        filename: "评分项查看"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.chooseCheck {
  //position: absolute;
  //top: 90px;
  //left: 105px;
  margin-left: 30px;
}
.wd2 {
  width: 20px;
}
.wd10 {
  width: 100px;
}
.wd20 {
  width: 200px;
}
/deep/ .el-table tr {
  td,
  th {
    height: 36px !important;
    line-height: 36px !important;
    //padding: 5px 10px !important;
    //box-sizing: border-box !important;
    //text-overflow: ellipsis !important;
    //white-space: nowrap;
  }
}
/deep/ .el-table--border {
  th:last-of-type.gutter {
    display: table-cell !important;
    width: 0px !important;
  }
}
</style>
